import { Funcionalidades } from '@/config/funcionalidades';
// import FlotaVehiculo from './FlotaVehiculo/index.vue';
// import EditarVehiculoPantalla from './EditarVehiculos/EditarVehiculosPantalla.vue';
// import AltaTecnicoPantalla from './AltaTecnico/AltaTecnicoPantalla.vue';
// import ActivarIntegracion from './ActivarIntegracion/index.vue';
// import ClasificacionPatentes from './ClasificacionPatentes/index.vue';
// import ConfiguracionCamaras from './ClasificacionPatentes/IndexConfiguracionCamara.vue';
// import MantenedorServipagPantalla from './MantenedorServipag/MantenedorServipagPantalla.vue';
// import SimSolicitudesPantalla from './SIMSolicitudes/SimSolicitudesPantalla.vue';
// import BitacoraPantalla from './Bitacora/BitacoraPantalla.vue';
// import DevolucionesPantalla from './Devoluciones/DevolucionesPantalla.vue';
// import AltasDeServicio from './AltasServicio/index.vue';
// import ReportesSeriePantalla from './ReportesNoSeriados/ReportesSeriePantalla.vue';
// import MatrizProductoPantalla from './MatrizProducto/MatrizProductoPantalla.vue';
// import TiposProductoPantalla from './TiposProducto/TiposProductoPantalla.vue';
// import GrillaOrdenesCompra from './OrdenesCompra/index.vue';
// import MantenedorTelcoPantalla from './MantenedorTelco/MantenedorTelcoPantalla.vue';
// import CambiosdeServicio from './CambiosServicio/index.vue';
// import SolicitudAnulacionVenta from './solicitudAnulacionVenta/index.vue';
// import MantenedorLocalidadPantalla from './MantenedorLocalidad/MantenedorLocalidadPantalla.vue';
// import MotivodeBajaPantalla from './MotivodeBaja/MotivodeBajaPantalla.vue';
// import MantenedorCoordinadorPantalla from './MantenedorCoordinador/MantenedorCoordinadorPantalla.vue';
// import GrillaReportesConecta from './ReportesConecta/index.vue';
// import SolicitudBajaCliente from './SolicitudBajaCliente/SolicitudBajaCliente.vue';
// import ConfigAutorizacionesPantalla from './ConfigAutorizaciones/ConfigAutorizacionesPantalla.vue';
// import ModuloAutorizacionPantalla from './ModuloAutorizacion/ModuloAutorizacionPantalla.vue';
// import MantenedorTipoUbicacionPantalla from './MantenedorTipoUbicacion/MantenedorTipoUbicacionPantalla.vue';
// import InformePreparacionPantalla from './InformePreparacion/InformePreparacionPantalla.vue';
// import SolicitudBajaSim from './SolicitudBajaSim/SolicitudBajaSim.vue';
// import RegistrarBajaSim from './RegistrarBajaSim/RegistrarBajaSim.vue';
// import VerificacionBajaCliente from './VerificacionBajaCliente/VerificacionBajaCliente.vue';
// import ControlBajaCliente from './ControlBajaCliente/ControlBajaCliente.vue';
// import ConfiguracionAlarmas from './ConfiguracionAlarmas/ConfiguracionAlarmas.vue';
// import ConsultaInstalacionesPantalla from '@/pantallas/Conecta/ConsultaInstalaciones/ConsultaInstalacionesPantalla.vue';
// import EstructuraComercialPantalla from './MantenedorEstructuraCom/EstructuraComercialPantalla.vue';
// import AtencionesPantalla from './Atenciones/AtencionesPantalla.vue';
// import NDVPantalla from '@/pantallas/Conecta/NDV/NDVPantalla.vue';
// import BajasComercialesPantalla from './BajasComerciales/BajasComercialesPantalla.vue';
// import AddPantalla from './Add/AddPantalla.vue';
//import ConectaCuadraturas from './Cuadraturas/index.vue';
//import OrdenesSerTecPantalla from './OrdenesSerTec/OrdenesSerTecPantalla.vue';

const ConectaRoutes = [
  {
    path: 'modulo-autorizaciones',
    component: () =>
      import('./ModuloAutorizacion/ModuloAutorizacionPantalla.vue'),
    meta: {
      description: 'Módulo de Autorizacones',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.ModuloAutorizaciones,
    },
  },
  {
    path: 'Flota-Vehiculo',
    component: () => import('./FlotaVehiculo/index.vue'),
    meta: {
      description: 'Flota Vehículo',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.FlotaVehiculo,
    },
  },
  {
    path: 'MantenedorServipag',
    component: () =>
      import('./MantenedorServipag/MantenedorServipagPantalla.vue'),
    meta: {
      description: 'MantenedorServipag',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.MantenedorServipag,
    },
  },
  {
    path: 'MotivodeBaja',
    component: () => import('./MotivodeBaja/MotivodeBajaPantalla.vue'),
    meta: {
      description: 'Motivo de Baja',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.MotivodeBaja,
    },
  },
  {
    path: 'editar-vehiculos',
    component: () => import('./EditarVehiculos/EditarVehiculosPantalla.vue'),
    meta: {
      description: 'Editar Vehículo',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.EditarVehiculos,
    },
  },
  {
    path: 'alta-tecnico',
    component: () => import('./AltaTecnico/AltaTecnicoPantalla.vue'),
    meta: {
      description: 'Alta de Tecnico',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.AltaTecnico,
    },
  },
  {
    path: 'tipo-de-equipo',
    component: () => import('./MatrizProducto/MatrizProductoPantalla.vue'),
    meta: {
      description: 'Matriz de Producto',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.MatrizProducto,
    },
  },
  {
    path: 'Sim-Ingresos',
    component: () => import('./SIMSolicitudes/SimSolicitudesPantalla.vue'),
    meta: {
      description: 'Vista SIM Solicitudes',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.SimSolicitudes,
    },
  },
  {
    path: 'tipo-de-producto',
    component: () => import('./TiposProducto/TiposProductoPantalla.vue'),
    meta: {
      description: 'Tipos de Producto Comercial',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.TiposProducto,
    },
  },
  {
    path: 'bitacora',
    component: () => import('./Bitacora/BitacoraPantalla.vue'),
    meta: {
      description: 'Bitácora',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.Bitacora,
    },
  },
  {
    path: 'mantenedor-telcos',
    component: () => import('./MantenedorTelco/MantenedorTelcoPantalla.vue'),
    meta: {
      description: 'Mantendor Telcos',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.MantenedorTelco,
    },
  },
  {
    path: 'mantenedor-estructura-com',
    component: () =>
      import('./MantenedorEstructuraCom/EstructuraComercialPantalla.vue'),
    meta: {
      description: 'Estructura Comercial',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.EstructuraComercialCom,
    },
  },
  {
    path: 'Activar-Integracion',
    component: () => import('./ActivarIntegracion/index.vue'),
    meta: {
      description: 'Activar Integración',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.IntegracionVehiculo,
    },
  },
  {
    path: 'Clasificacion-Patentes-Camaras',
    component: () => import('./ClasificacionPatentes/index.vue'),
    meta: {
      description: 'Clasificación Patentes Camaras',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.ClasificacionPatentes,
    },
  },
  {
    path: 'configuracion-camaras',
    component: () =>
      import('./ClasificacionPatentes/IndexConfiguracionCamara.vue'),
    meta: {
      description: 'Configuración Cámaras',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.ConfiguracionCamaras,
    },
  },
  {
    path: 'conecta-reportes',
    component: () => import('./ReportesConecta/index.vue'),
    meta: {
      description: 'Reportes',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.GrillaReportesConecta,
    },
  },
  {
    path: 'conecta-ordenes-compra',
    component: () => import('./OrdenesCompra/index.vue'),
    meta: {
      description: 'Reportes',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.OrdenesCompra,
    },
  },
  {
    path: 'conecta-cuadraturas',
    component: () => import('./Cuadraturas/index.vue'),
    meta: {
      description: 'Reportes',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.conecta_cuadraturas,
    },
  },
  {
    path: 'conecta-solicitud-anulacion-venta',
    component: () => import('./solicitudAnulacionVenta/index.vue'),
    meta: {
      description: 'SAV',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.SolicitudAnulacionVenta,
    },
  },
  {
    path: 'mantenedor-de-localidad',
    component: () =>
      import('./MantenedorLocalidad/MantenedorLocalidadPantalla.vue'),
    meta: {
      description: 'Mantenedor de Localidad',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.localidad,
    },
  },
  {
    path: 'mantenedor-de-coordinadores',
    component: () =>
      import('./MantenedorCoordinador/MantenedorCoordinadorPantalla.vue'),
    meta: {
      description: 'Mantenedor de Coordinadores',
      requireAuth: true,
      moduloCodigo: Funcionalidades.coordinador,
    },
  },
  {
    path: 'Configuracion-Autorizaciones',
    component: () =>
      import('./ConfigAutorizaciones/ConfigAutorizacionesPantalla.vue'),
    meta: {
      description: 'Vista Configuración de Autorizaciones',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.ConfigAutorizaciones,
    },
  },
  {
    path: 'alta-tecnico',
    component: () => import('./AltaTecnico/AltaTecnicoPantalla.vue'),
    meta: {
      description: 'Alta de Tecnico',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.AltaTecnico,
    },
  },
  {
    path: 'tipo-de-equipo',
    component: () => import('./MatrizProducto/MatrizProductoPantalla.vue'),
    meta: {
      description: 'Matriz de Producto',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.MatrizProducto,
    },
  },
  {
    path: 'Sim-Ingresos',
    component: () => import('./SIMSolicitudes/SimSolicitudesPantalla.vue'),
    meta: {
      description: 'Vista SIM Solicitudes',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.SimSolicitudes,
    },
  },
  {
    path: 'tipo-de-producto',
    component: () => import('./TiposProducto/TiposProductoPantalla.vue'),
    meta: {
      description: 'Tipos de Producto Comercial',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.TiposProducto,
    },
  },
  {
    path: 'bitacora',
    component: () => import('./Bitacora/BitacoraPantalla.vue'),
    meta: {
      description: 'Bitácora',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.Bitacora,
    },
  },
  {
    path: 'conecta-altas-servicio',
    component: () => import('./AltasServicio/AltasDeServicioPantalla.vue'),
    meta: {
      description: 'Altas de servicio',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.AltasDeServicio,
    },
  },
  {
    path: 'mantenedor-telcos',
    component: () => import('./MantenedorTelco/MantenedorTelcoPantalla.vue'),
    meta: {
      description: 'Mantendor Telcos',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.MantenedorTelco,
    },
  },
  {
    path: 'configuracion-alarmas',
    component: () => import('./ConfiguracionAlarmas/ConfiguracionAlarmas.vue'),
    meta: {
      description: 'Configuracion De Alarmas',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.ConfiguracionAlarmas,
    },
  },
  {
    path: 'mantenedor-de-tipo-de-ubicacion',
    component: () =>
      import('./MantenedorTipoUbicacion/MantenedorTipoUbicacionPantalla.vue'),
    meta: {
      description: 'Mantenedor de Tipo Ubicación',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.TipoUbicacion,
    },
  },
  {
    path: 'SolicitudBajaSimTarjeta',
    component: () => import('./SolicitudBajaSim/SolicitudBajaSim.vue'),
    meta: {
      description: 'SolicitudBajaSimTarjeta',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.SolicitudBajaSimTarjeta,
    },
  },
  {
    path: 'RegistrarBajaSim',
    component: () => import('./RegistrarBajaSim/RegistrarBajaSim.vue'),
    meta: {
      description: 'RegistrarBajaSim',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.RegistrarBajaSim,
    },
  },
  {
    path: 'SolicitudBajaCliente',
    component: () => import('./SolicitudBajaCliente/SolicitudBajaCliente.vue'),
    meta: {
      description: 'Reportes',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.SolicitudBajaCliente,
    },
  },
  {
    path: 'VerificacionBajaCliente',
    component: () =>
      import('./VerificacionBajaCliente/VerificacionBajaCliente.vue'),
    meta: {
      description: 'Verificacion Baja Cliente',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.VerificacionBajaCliente,
    },
  },
  {
    path: 'ControlBajaCliente',
    component: () => import('./ControlBajaCliente/ControlBajaCliente.vue'),
    meta: {
      description: 'Consulta Control Baja Cliente',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.ControlBajaCliente,
    },
  },
  {
    path: 'consulta-instalaciones',
    component: () =>
      import('./ConsultaInstalaciones/ConsultaInstalacionesPantalla.vue'),
    meta: {
      description: 'Consulta de Instalaciones',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.ConsultaInstalaciones,
    },
  },
  {
    path: 'atenciones',
    component: () => import('./Atenciones/AtencionesPantalla.vue'),
    meta: {
      description: 'Módulo de Atenciones',
      requireAuth: true,
      moduloCodigo: Funcionalidades.Atenciones,
    },
  },
  {
    path: 'notas-ventas',
    component: () => import('./NDV/NDVPantalla.vue'),
    meta: {
      description: 'Nota de Ventas',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.NDV,
    },
  },
  {
    path: 'actividades-despachos',
    component: () => import('./Add/AddPantalla.vue'),
    meta: {
      description: 'Actividades de Despachos',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.Add,
    },
  },
  {
    path: 'conecta-ordenes-serTec',
    component: () => import('./OrdenesSerTec/OrdenesSerTecPantalla.vue'),
    meta: {
      description: 'Ordenes de Servicio SerTec',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.OrdenesSerTec,
    },
  },
  {
    path: 'bajas-comerciales',
    component: () => import('./BajasComerciales/BajasComercialesPantalla.vue'),
    meta: {
      description: 'Bajas Comerciales',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.BajasComerciales,
    },
  },
  {
    path: 'bajas-cobranza',
    component: () => import('./BajasCobranza/index.vue'),
    meta: {
      description: 'Bajas Cobranza',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.BajasCobranza,
    },
  },
  {
    path: 'mantenedor-transbank',
    component: () =>
      import('./MantenedorTransbank/MantenedorTransbankPantalla.vue'),
    meta: {
      description: 'MantenedoTransbank',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.MantenedorTransbank,
    },
  },
  {
    path: 'conecta-altas-crm',
    component: () => import('./AltasCrm/AltasCrmPantalla.vue'),
    meta: {
      description: 'Altas Crm',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.AltaCrm,
    },
  },
  {
    path: 'mantenedor-tramos',
    component: () => import('./MantenedorTramos/MantenedorTramosPantalla.vue'),
    meta: {
      description: 'Mantenedor de Tramos',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.MantenedorTramos,
    },
  },
  {
    path: 'solicitud-stock',
    component: () => import('./SolicitudStock/SolicitudStockPantalla.vue'),
    meta: {
      description: 'Solicitud Stock',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.SolicitudStock,
    },
  },
];

export default ConectaRoutes;
